const PIPE = ' | ';

export const WINNER_TYPES = {
    FAN: 'fanWinner',
    MEDIA: 'mediaWinner',
    UNANIMOUS: 'unanimousWinner'
};
const {
    FAN,
    MEDIA,
    UNANIMOUS
} = WINNER_TYPES;

class PlayerOfTheGameWinnersModel {
    constructor (data) {
        const {
            fanWinner = {},
            mediaWinner = {}
        } = data || {};

        this.winners = [];
        this.winnerIds = [];
        this.buildWinners(fanWinner, mediaWinner);
    }

    buildWinners (fanWinner, mediaWinner) {
        const winners = [];
        const winnerIds = [];
        if (fanWinner.feedId && fanWinner.feedId === mediaWinner.feedId) {
            winners.push({
                ...fanWinner,
                type: UNANIMOUS,
                statLine: {
                    en: this.parseStatLine(fanWinner.summary),
                    es: this.parseStatLine(fanWinner.summaryES)
                }
            });
            winnerIds.push(fanWinner.feedId);
        } else {
            if (fanWinner.feedId) {
                winners.push({
                    ...fanWinner,
                    type: FAN,
                    statLine: {
                        en: this.parseStatLine(fanWinner.summary),
                        es: this.parseStatLine(fanWinner.summaryES)
                    }
                });
                winnerIds.push(fanWinner.feedId);
            } if (mediaWinner.feedId) {
                winners.push({
                    ...mediaWinner,
                    type: MEDIA,
                    statLine: {
                        en: this.parseStatLine(mediaWinner.summary),
                        es: this.parseStatLine(mediaWinner.summaryES)
                    }
                });
                winnerIds.push(mediaWinner.feedId);
            }
        }
        this.winnerIds = winnerIds;
        this.winners = winners;
    }

    parseStatLine (summary) {
        const segments = summary.split(PIPE);
        let statLine = '';
        for (let i = 0; i < segments.length; i++) {
            if (i > 0) {
                statLine += '\n';
            }
            statLine += segments[i];
        }
        return statLine;
    }
}

export default PlayerOfTheGameWinnersModel;
